import { slices } from "@/constants/sliceNames";
import { CameraGroup } from "@/entities/Camera/CameraGroup";
import { Prefixs } from "@/socket/socketPrefix";
import {
  requestListOfCameraGroupsStatus,
  requestCameraGroupByIdStatus,
  requestCreateCameraGroupStatus,
  requestAddCameraToCameraGroupStatus,
  requestDeleteCameraGroupStatus,
  requestUpdateCameraGroupStatus,
  requestConnectToCameraGroupStatus,
  requestDisconnectFromCameraGroupStatus,
  requestCameraGroupFramesStatus,
  requestCameraGroupFrameImagesStatus,
  requestNumOfImagesInCameraGroupStatus,
} from "@/store/effects/camera/cameraGroups-effects";
import { cameraActions, cameraWebSocket } from "@/store/effects/camera/utils";
import { WEBSOCKET_MESSAGE } from "@giantmachines/redux-websocket/dist";
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  /** @type {CameraGroup[]} */
  cameraGroups: [],

  /** @type {CameraGroup} */
  cameraGroup: new CameraGroup(),

  /**@type {[]Object} */
  frames: [],

  /**@type {[]Object} */
  cameraGroupDetails: [],

  /** @type {boolean} */
  loading: false,

  /** @type {number} */
  currentPage: 0,

  /** @type {number} */
  pageLimit: 0,

  /** @type {number} */
  recordsCount: 0,

  /** @type {number} */
  totalPages: 0,

  /** @type {string} */
  message: "",

  /** @type {string} */
  error: "",

  connection: {
    /** @type {boolean} */
    loading: false,
    /** @type {string} */
    error: "",
    /** @type {string} */
    message: "",
  },

  streaming: [],

  // This is to hold number of images in camera group
  // used to display in camera group details
  // As it requires another API call to get this
  // so It's added outside cameraGroup state to avoid overriding
  /** @type {number} */
  cameraGroupSize: 0,
  appliedFiltersOnFrames: {},
};

const cameraSlice = createSlice({
  name: slices.cameraGroups,
  initialState,
  reducers: {},
  extraReducers: {
    ...requestListOfCameraGroupsStatus,
    ...requestCameraGroupByIdStatus,
    ...requestCreateCameraGroupStatus,
    ...requestAddCameraToCameraGroupStatus,
    ...requestDeleteCameraGroupStatus,
    ...requestUpdateCameraGroupStatus,
    ...requestConnectToCameraGroupStatus,
    ...requestDisconnectFromCameraGroupStatus,
    ...requestCameraGroupFramesStatus,
    ...requestCameraGroupFrameImagesStatus,
    ...requestNumOfImagesInCameraGroupStatus,
    [`${Prefixs.CAMERA_GROUP_PREFIX}::${WEBSOCKET_MESSAGE}`]: (state, action) => {
      const images = JSON.parse(action?.payload?.message);
      state.cameraGroup.size += state.cameraGroup.cameras.length;
      images.forEach((image, index) => {
        state.streaming[index] = { cameraId: image.camera_id };
        state.streaming[index] = cameraWebSocket(state.streaming[index], image.type, cameraActions.prediction, image);
      });
    },
  },
});

const { reducer } = cameraSlice;

export default reducer;
